<template>
	<a href="#" @click="clickMenuItem(menuItem.url, menuItem.offset)">{{
		menuItem.name
	}}</a>
</template>

<script>
export default {
	name: 'MenuItem',
	props: {
		menuItem: {
			type: Object,
			required: true
		}
	},
	methods: {
		scrollTo(v, offset) {
			let defaultOffset = -40;
			this.$scrollTo(`${v}`, { offset: offset || defaultOffset });
		},
		clickMenuItem(v, offset) {
			this.scrollTo(v, offset);
			//TODO better way to do this??
			document.getElementById('hiden__menu__item__publisher').checked = false;

			if (document.querySelector('body').classList.contains('menu-is-open')) {
				document.querySelector('body').classList.remove('menu-is-open');
			} else {
				document.querySelector('body').classList.add('menu-is-open');
			}
		}
	}
}
</script>

<style scoped></style>
